import React, {Fragment, useEffect, useState} from 'react';
import {ReactComponent as DownloadSvg} from '../../../../../assets/icons/download1.svg';
import AvatarUser from '../../../../../assets/images/avatars/avatar-users.png';
import AvatarAdmin from '../../../../../assets/images/avatar.png';
import {ReactComponent as FileUser} from '../../../../../assets/icons/addFiles.svg';
import {ReactComponent as Reply} from '../../../../../assets/icons/reply.svg';
import {ReactComponent as Reply2} from '../../../../../assets/icons/reply2.svg';
import {ReactComponent as Arrow} from '../../../../../assets/icons/arrow.svg';
import './ChatList.scss';
import {convertSizeUi, hasPermission} from '../../../../../helpers/functions';
import {parseTextWithLinks, PERMISSIONS} from '../../../../../helpers/constants';
import {useTranslation} from "react-i18next";
import VideoWithPoster from "../../../VideoWithPoster/VideoWithPoster";
import {useDispatch, useSelector} from "react-redux";
import {closeModal, setModal, setModalData} from "../../../../../redux/actions/app/appActions";
import {POPUPS} from "../../../../../redux/actions/app/appActionTypes";
import {getChatMessage} from "../../../../../redux/actions/projects/projectsActions";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadPanel from "../../../LoadPanel";

const formatDateKey = (dateString) => {
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // 2026-03-14
};

const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, message) => {
        const dateKey = formatDateKey(message.created_at);
        if (!acc[dateKey]) acc[dateKey] = [];
        acc[dateKey].push(message);
        return acc;
    }, {});
};

const ChatList = ({
                      variant,
                      list,
                      profileMeId,
                      messagesEndRef,
                      handleClickOutside,
                      handleRightClick,
                      clickReply,
                      hasMore,
                      fetchOlderMessages
                  }) => {
        const profileMe = useSelector((state) => state.profile.profileMe);
        const {singleProject} = useSelector((state) => state.projects);
        const dispatch = useDispatch();
        const {t} = useTranslation()
        const messagesByDate = groupMessagesByDate(list.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)));
        const sortedDates = Object.keys(messagesByDate).sort((a, b) => new Date(a) - new Date(b));
        const [isAtBottom, setIsAtBottom] = useState(true);
        const permissionSending = hasPermission(PERMISSIONS.CHAT_MESSAGES, profileMe?.permissions ?? []);
        const allowSending = (singleProject?.status === 'active' || singleProject?.status === 'pause') && permissionSending
        const handleScroll = () => {
            handleClickOutside();
        };
        const handleScrolled = () => {
            const el = messagesEndRef.current;
            if (!el) return;
            setIsAtBottom(el.scrollTop >= 0);
        };


        useEffect(() => {
            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }, []);

        useEffect(() => {
            const el = messagesEndRef.current;
            if (!el) return;

            el.addEventListener('scroll', handleScrolled);
            return () => {
                el.removeEventListener('scroll', handleScrolled);
            };
        }, []);


        const handleOpenPreview = async (indexPhoto, chatId, id, name) => {
            dispatch(setModal(POPUPS.PHOTO_PREVIEW))
            dispatch(setModalData({
                projectId: singleProject?.id,
                chatId,
                id,
                indexPhoto,
                name
            }))
        }


        const downloadHandler = (fileName, chatId, id, indexFile) => {
            dispatch(setModal(POPUPS.PREPARING_POPUP));
            dispatch(getChatMessage(singleProject?.id, chatId, id)).then(async (res) => {
                if (res.payload) {
                    const fileUrl = res.payload.data.data?.files?.[indexFile]?.path;
                    if (fileUrl) {
                        try {
                            const response = await fetch(fileUrl)
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName || 'downloaded_file';
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(url);
                        } catch (e) {
                            console.error('Ошибка при скачивании файла:', e);
                        }
                    } else {
                        console.error('Путь к файлу не найден');
                    }

                    dispatch(closeModal());
                } else {
                    dispatch(closeModal());
                }
            });
        };


        const RenderFile = ({date, chatId, id, indexFile}) => {
            const isImage = /\.(jpg|jpeg|png|webp)$/i.test(date.name);

            return <Fragment>{isImage ? <div className={'photos'}>
                    <img height={150} onClick={() => handleOpenPreview(indexFile, chatId, id, date.name)} src={date.path || ''}
                         alt={date.name || ''}/>
                </div> :
                <div className='files'>
                    <div className='files-details'>
                        <div className='files-img'>
                            <FileUser/>
                        </div>
                        <div className='files-info'>
                            <div className='files-info__left'>
                                <div className={'files-name'}>{date.name}
                                </div>
                                <p className={'files-size'}>{convertSizeUi(date.size)}</p>
                            </div>
                            <div
                                onClick={() => downloadHandler(date.name, chatId, id, indexFile)}
                                className='files-info__right'>
                                <DownloadSvg/>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </Fragment>
        }

        const scrollToBottom = () => {
            const el = messagesEndRef.current;
            if (el) {
                el.scrollTo({top: el.scrollHeight, behavior: 'smooth'});
            }
        };

    return (
            <div
                className={`chat-list chat-list__${variant}${!allowSending ? ' disabled-view' :''}`}
                id='scrollableDiv'
                ref={messagesEndRef}
                onClick={handleClickOutside}
                style={{
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column-reverse',
                    border: '1px solid gray',
                }}
            >
                <InfiniteScroll
                    dataLength={list.length}
                    next={fetchOlderMessages}
                    hasMore={hasMore}
                    inverse={true}
                    scrollableTarget="scrollableDiv"
                    loader={
                        <div className='chat-list-more'>
                            <LoadPanel noBg={true} circleSize={20} staticPos={true}/>
                        </div>
                    }
                >
                    {sortedDates.map((date, index) => (
                        <div key={index} className='chat-day'>
                            <div className='chat-day__date'>
                                <span>
                                    {new Date(date).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                                </span>
                            </div>
                            {messagesByDate[date].map((message) => {
                                const foundMessage = message?.parent ? message?.parent : null

                                if (message.type === 'system_text' || message.type === 'system_file') {
                                    return (
                                        <div className={`system-message`} key={message.id}>
                                            <div className='system-message__content'>
                                                <div className='system-message__head'>
                                                    <div className='system-message__avatar'>
                                                        <img src={AvatarAdmin} alt='avatar'/>
                                                    </div>
                                                    <div className='system-message__user-sender'>DAR</div>
                                                    <span className={'system-message__default'}>системна розсилка</span>
                                                </div>
                                                <div className='system-message__text'>
                                                    <div className='system-message__message'>
                                                        {message.files.length > 0 &&
                                                            message.files.map((date, index) => (
                                                                <RenderFile key={index} date={date} index={index}
                                                                            id={message.id}
                                                                            chatId={message.chatId}
                                                                            indexFile={index}
                                                                />
                                                            ))}
                                                        {parseTextWithLinks(message.message)}
                                                    </div>
                                                    <div
                                                        className='system-message__time'>{new Date(message.created_at).toLocaleTimeString()}</div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }

                                const isActiveMessage = message.active || message.sender.id === profileMeId

                                const hasVideo = message.videos.length > 0

                                return (
                                    <div
                                        onContextMenu={(e) => {
                                            if(!allowSending) return
                                            handleRightClick(e, message);
                                        }}
                                        className={`chat-message ${isActiveMessage ? 'active' : ''}`}
                                        id={`message-${message.id}`}
                                        key={message.id}
                                    >
                                        {isActiveMessage && allowSending ?
                                            <div className='chat-message__reply active'
                                                 onClick={(e) => {
                                                     clickReply(message);
                                                 }}
                                            >
                                                <Reply/></div>
                                            : null}
                                        {message.sender.avatar.main ? (
                                            <div className='chat-message__avatar'>
                                                <img src={message.sender.avatar.main} alt='avatar'/>
                                            </div>
                                        ) : (
                                            <div className='chat-message__avatar'>
                                                <img src={AvatarUser} alt='avatar'/>
                                            </div>
                                        )}

                                        <div className='chat-message__content'>
                                            {foundMessage && Object.keys(foundMessage).length && (
                                                <div className={'chat-message__respond'}>
                                                    <div className={'chat-message__respond-data'}>
                                                        {foundMessage.sender.firstName}
                                                        <span>{foundMessage.sender.positionName}</span>
                                                    </div>

                                                    {foundMessage.videos.length > 0 &&
                                                        foundMessage.videos.map((video, index) => {
                                                            return (
                                                                <div key={index} className='videos'>
                                                                    <VideoWithPoster src={video.path} id={foundMessage.id}
                                                                                     chatId={foundMessage.chatId}
                                                                                     indexVideo={index}/>
                                                                </div>
                                                            )
                                                        })}
                                                    {foundMessage.files.length > 0 &&
                                                        foundMessage.files.map((date, index) => (
                                                            <RenderFile key={index} date={date} index={index}
                                                                        id={foundMessage.id}
                                                                        chatId={foundMessage.chatId}
                                                                        indexFile={index}
                                                            />
                                                        ))}
                                                    <div className='chat-message__respond-msg'>
                                                        {foundMessage?.message || foundMessage?.files?.map((file) => file.name).join(', ') || t('all.filee')}
                                                    </div>
                                                </div>
                                            )}
                                            <div className='chat-message__user'>
                                                <div className='chat-message__user-sender'>
                                                    {message.sender.firstName} {message.sender.lastName || ''}
                                                </div>
                                                <div className='chat-message__user-role'>
                                                    {message.sender.position ? t(`roles.${message.sender.position}`) : null}
                                                </div>
                                            </div>
                                            <div className='chat-message__text'>
                                                <div className='chat-message__message'>
                                                    {message.videos.length > 0 &&
                                                        message.videos.map((video, index) => (
                                                            <div key={index} className='videos'>
                                                                <VideoWithPoster src={video.path} id={message.id}
                                                                                 chatId={message.chatId}
                                                                                 indexVideo={index}/>
                                                            </div>
                                                        ))}
                                                    {message.files.length > 0 &&
                                                        message.files.map((date, index) => {
                                                            return <RenderFile key={index} date={date} index={index}
                                                                               id={message.id}
                                                                               chatId={message.chatId}
                                                                               indexFile={index}
                                                            />
                                                        })}
                                                    {hasVideo ?
                                                        <div className={'chat-message__video'}>
                                                            {parseTextWithLinks(message.message)}
                                                            <div
                                                                className='chat-message__time'>{new Date(message.created_at).toLocaleTimeString()}</div>
                                                        </div> : <>
                                                            {parseTextWithLinks(message.message)}
                                                        </>}

                                                </div>
                                                {!hasVideo && <div
                                                    className='chat-message__time'>{new Date(message.created_at).toLocaleTimeString()}</div>}
                                            </div>
                                        </div>

                                        {!isActiveMessage && allowSending ? <div className='chat-message__reply' onClick={(e) => {
                                            clickReply(message);
                                        }}><Reply2/></div> : ''}

                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </InfiniteScroll>
                <div className={`chat-list__scrollable ${isAtBottom ? 'hidden' : ''}`} onClick={scrollToBottom}>
                    <Arrow/>
                </div>
            </div>
        );
    }
;

export default ChatList;
